export default {
  SET_SHAREWORK(state, payload) {
    state.shareWork = payload;
  },
  READ_MORE(state, payload) {
    state.readMore = payload;
  },
  READ_LESS(state, payload) {
    state.readLess = payload;
  },
};
